module.exports = __webpack_public_path__ + "img/product6.d6ff5336.png";